import React from 'react'

/**
 * Context to hold a reference to the HeaderContainer div that holds the navbar menu.
 * @type {React.Context<null>}
 */
const HeaderContainerRefContext = React.createContext(null);

export default HeaderContainerRefContext;
